import type { Task } from "~/shared/types";
import { useDataStore } from "~/stores";
import { getPageDisplayName } from "~/utils/common";
import { makeDartboardComparator } from "~/utils/comparator";

import type { Actions } from "..";

export default (_actions: Actions) => ({
  /**
   * Group and sort tasks by dartboard with optional current dartboard prioritization
   */
  groupAndSortTasksByDartboard: (tasks: Task[], currentDartboardDuid?: string | null) => {
    const dataStore = useDataStore();

    const grouped = new Map<string, Task[]>();

    tasks.forEach((task) => {
      const dartboard = dataStore.getDartboardByDuid(task.dartboardDuid);
      const dartboardDisplayName = getPageDisplayName(dartboard, dataStore.getSpaceByDuid, "abrev") || "Dartboard";

      const group = grouped.get(dartboardDisplayName);
      if (group) {
        group.push(task);
      } else {
        grouped.set(dartboardDisplayName, [task]);
      }
    });

    const sortedEntries = Array.from(grouped.entries()).sort(([, tasksA], [, tasksB]) => {
      const dartboardA = dataStore.getDartboardByDuid(tasksA[0]?.dartboardDuid);
      const dartboardB = dataStore.getDartboardByDuid(tasksB[0]?.dartboardDuid);

      // If we have a current dartboard, prioritize it
      if (currentDartboardDuid) {
        const isACurrentDartboard = dartboardA?.duid === currentDartboardDuid;
        const isBCurrentDartboard = dartboardB?.duid === currentDartboardDuid;

        if (isACurrentDartboard && !isBCurrentDartboard) {
          return -1;
        }
        if (isBCurrentDartboard && !isACurrentDartboard) {
          return 1;
        }
      }

      return makeDartboardComparator(dataStore.getSpaceByDuid)(dartboardA, dartboardB);
    });

    return sortedEntries;
  },
});
